import { inject } from "vue";

const mainRoutes = [
    {
        path: "/",
        name: "login",
        component: () =>
            import(
      /*webpackChunkName: 'component-login' */ "@/pages/LoginPage.vue"
            ),
        beforeEnter: (to, from, next) => {
            const store = inject("store");
            if (store.authModule.getters.isAuthenticated()) {
                if (store.authModule.getters.isCustomer()) {
                    next("/customer/activity");
                } else {
                    next("/notAvailable");
                }
            } else {
                next();
            }
        }
    }, {
        path: "/home",
        name: "home",
        component: () => import("@/pages/NotFoundPage.vue"),
        beforeEnter: (to, from, next) => {
            const store = inject("store");
            if (store.authModule.getters.isAuthenticated()) {
                if (store.authModule.getters.isCustomer()) {
                    next("/customer/activity");
                } else {
                    next("/notAvailable");
                }
            } else {
                next();
            }
        }
    },
    {
        path: "/notAvailable",
        name: "notAvailable",
        component: () =>
            import(
      /*webpackChunkName: 'component-admin' */ "@/pages/NotAvailableJetPage.vue"
            ),
    }
];

export default mainRoutes;
